/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileSimple } from '../../models/profile-simple';

export interface ListProfileRandomForUser$Params {
  max: number;

/**
 * If set to TRUE than returned profiles are already followed by user -> otherwise profiles are not follwed.
 */
  following: boolean;
  minActivities: number;
}

export function listProfileRandomForUser(http: HttpClient, rootUrl: string, params: ListProfileRandomForUser$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileSimple>>> {
  const rb = new RequestBuilder(rootUrl, listProfileRandomForUser.PATH, 'get');
  if (params) {
    rb.path('max', params.max, {});
    rb.path('following', params.following, {});
    rb.path('minActivities', params.minActivities, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProfileSimple>>;
    })
  );
}

listProfileRandomForUser.PATH = '/rest/profile/random-for-user/{max}/{following}/{minActivities}';
